interface DacrJWTPayload {
  uid: string
  token_use: 'access' | 'refresh'
  iat: number
  exp: number
  iss: string
  sub: string
}

export const decodeJWT = (jwt: string): DacrJWTPayload | null => {
  if (!jwt || !jwt.length || jwt.split('.').length !== 3) {
    return null
  }

  const payloadPart = jwt.split('.')[1]
  const decodedPayload = JSON.parse(window.atob(payloadPart))

  return decodedPayload
}
